<template>
  <div id="app">
    <router-view/>
  </div>
</template>
<script>
export default {
  name: 'App',
  data () {
    return {}
  },
  methods: {}
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  /* color: #2c3e50;
  margin-top: 30px; */
}
body {
  margin: 0 !important;
}
/* h2 {
    display: inline-block;
    margin-right: 20px;
  } */
</style>



// WEBPACK FOOTER //
// src/App.vue